import Pusher from 'pusher-js'
import type { Channel } from 'pusher-js'

let pusherInstance: Pusher | null = null

export function usePusher() {
  function getInstance(): Pusher | null {
    if (import.meta.server) return null
    if (!pusherInstance) {
      const key = import.meta.env.VITE_PUSHER_APP_KEY
      const cluster = import.meta.env.VITE_PUSHER_CLUSTER
      if (!key || !cluster) return null
      pusherInstance = new Pusher(key, { cluster })
    }
    return pusherInstance
  }

  function subscribe(channelName: string): Channel | null {
    const pusher = getInstance()
    if (!pusher) return null
    return pusher.subscribe(channelName)
  }

  function unsubscribe(channelName: string) {
    const pusher = getInstance()
    if (!pusher) return
    pusher.unsubscribe(channelName)
  }

  return {
    getInstance,
    subscribe,
    unsubscribe,
  }
}
